import type { LayerProps } from 'react-map-gl/mapbox';

export const clusterLayer: LayerProps = {
  filter: ['has', 'point_count'],
  id: 'clusters',
  paint: {
    'circle-color': '#20bea8',
    'circle-radius': ['step', ['get', 'point_count'], 10, 100, 15, 750, 25]
  },
  source: 'inventory-explorer-source-id',
  'source-layer': 'layer',
  type: 'circle'
};

export const clusterCountLayer: LayerProps = {
  filter: ['has', 'point_count'],
  id: 'cluster-count',
  layout: {
    'text-field': '{point_count}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 12
  },
  paint: {
    'text-color': '#fff'
  },
  source: 'inventory-explorer-source-id',
  'source-layer': 'layer',
  type: 'symbol'
};

export const unclusteredPointLayer: LayerProps = {
  id: 'unclustered-point',
  paint: {
    'circle-color': '#20bea8',
    'circle-radius': 4,
    'circle-stroke-width': 0
  },
  source: 'inventory-explorer-source-id-unclustered',
  'source-layer': 'layer',
  type: 'circle'
};
